module.exports = __webpack_public_path__ + "img/img_box0.337dd0df.png";